__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['one-identity-login'].baseUrl;
import LoginComponent from './components/Login';
export default LoginComponent;
;
if (!global.BROWSER) {
  LoginComponent.appConfig = Object.assign({}, LoginComponent.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  LoginComponent.appConfig = Object.assign({}, LoginComponent.appConfig, {
    requiredExternals: {
      'iguazu-rpc': '^1.6.1'
    }
  });
}